import i18n from '@/plugins/i18n'

export default [
  {
    path: 'Chatroom',
    name: 'M0901Chatroom',
    component: () => import('@/app/M0901Chatroom/PgChatroomList.vue'),
    portalGroup: 'all.public',
    meta: { title: i18n.t('m0901.ChatRoom.title'), authenticated: true, template: 'UserTemplate' }
  }
]
